{
  "developers": [
    {
      "name": "Yan Kondratenko",
      "photo": "yan",
      "role": "Team Lead",
      "linkedin": "#",
      "github": "https://github.com/kondyan2022"
    },
    {
      "name": "Inna Zadorozhnia",
      "photo": "inna-zadorozhnia",
      "role": "Scrum Master",
      "linkedin": "https://www.linkedin.com/in/inna-zadorozhnia-07384827a/",
      "github": "https://github.com/InnaAnatoliivna"
    },
    {
      "name": "Igor Yatsenko",
      "photo": "igor",
      "role": "Developer",
      "linkedin": "https://www.linkedin.com/in/igor-yatsenko/",
      "github": "https://github.com/igorit22"
    },
    {
      "name": "Eduard Dzhuhan",
      "photo": "eduard",
      "role": "Developer",
      "linkedin": "https://www.linkedin.com/in/eduard-dzhuhan-49329627b/",
      "github": "https://github.com/PrimeGlorious"
    },
    {
      "name": "Inna Shkilna",
      "photo": "inna-shkilna",
      "role": "Developer",
      "linkedin": "https://www.linkedin.com/in/inkashkilna/",
      "github": "https://github.com/In-inka"
    },
    {
      "name": "Viktoria Sembai",
      "photo": "viktoria",
      "role": "Developer",
      "linkedin": "https://www.linkedin.com/in/sembaiviktoriia/",
      "github": "https://github.com/Vikki2Rikki"
    },
    {
      "name": "Vladyslav Smorodinov",
      "photo": "vladyslav",
      "role": "Developer",
      "linkedin": "https://www.linkedin.com/in/vladyslav-smorodinov-3b5b86279",
      "github": "https://github.com/Speerekk"
    },
    {
      "name": "Oleksandr Zhadanov",
      "photo": "oleksandr",
      "role": "Developer",
      "linkedin": "#",
      "github": "https://github.com/jadanov89"
    },
    {
      "name": "Tetiana Borovska",
      "photo": "tetiana",
      "role": "Developer",
      "linkedin": "#",
      "github": "https://github.com/pxntelle"
    },
    {
      "name": "Natalia Havashi",
      "photo": "natalia",
      "role": "Developer",
      "linkedin": "https://www.linkedin.com/in/natalia-havashi-8b7466274/",
      "github": "https://github.com/Natalia-Havashi"
    }
  ]
}